export default __webpack_public_path__ + "static/media/Hands_Black_Yellow.12a51bc5.png";